module.exports = ".w-timepicker-dialog {\n  padding: 0;\n  margin: -24px;\n  width: calc(100% + 48px); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/time-control/w-time-dialog/w-time-dialog.component.scss
// module id = 1597
// module chunks = 0